import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  CuratedThreadListLoadAction,
  GenerateCuratedThreadsAction,
} from '../../domains/curatedThreadList/actions.types';

import { CuratedThreadLists } from './types';

export type CuratedThreadListsAction = CuratedThreadListLoadAction | GenerateCuratedThreadsAction;

const initialState: CuratedThreadLists = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CuratedThreadLists, CuratedThreadListsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CURATED_THREAD_LIST_LOAD.PENDING':
      return moveToPending(state, [action.payload.curatedThreadListId]);
    case 'CURATED_THREAD_LIST_LOAD.REJECTED':
      return moveToRejected(state, [action.payload.curatedThreadListId], action.payload.error);
    case 'CURATED_THREAD_LIST_LOAD.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.curatedThreadLists);
    default:
      return state;
  }
};

export default reducer;
